import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { statusOptions, userRolesOptions } from '../../../utils/mics';

const UserDialog = ({ visible, onHide, user, onSave }) => {

    const [formData, setFormData] = useState(user || {});
    const [isFormValid, setIsFormValid] = useState(false); // For form validation
    const [errors, setErrors] = useState({}); // For error tracking
    const [touched, setTouched] = useState({}); // To track which fields were touched
    const isViewMode = user?.isView || false; // Determine if it's view mode

    useEffect(() => {
        if (visible) {

            let initialData = user || {};
            if (Object.keys(initialData || {}).length === 0) {
                initialData.status = "Active";
            }

            // Reset form state when the dialog is opened
            setFormData(initialData);
            setErrors({});
            setTouched({});
           // setIsFormValid(true); // Default to valid until proven otherwise
        }
    }, [user, visible]);

   // Validate form inputs to check if all fields are filled
    const validateForm = (data) => {
        const newErrors = {};
        let isValid = true;

        if (Object.keys(data || {}).length > 0) {
            if (!data.fullName) {
                newErrors.fullName = 'Full Name is required';
                isValid = false;
            }
            if (!data.userId) {
                newErrors.userId = 'User ID is required';
                isValid = false;
            }
            if (!data.password) {
                newErrors.password = 'Password is required';
                isValid = false;
            }
            if (!data.userRole) {
                newErrors.userRole = 'User Role is required';
                isValid = false;
            }
            if (!data.status) {
                newErrors.status = 'Status is required';
                isValid = false;
            }
            newErrors.error = '';
        } else { 
            isValid = false;
            newErrors.error = 'Please fill in all mandatory fields';
        }

        setErrors(newErrors);
        setIsFormValid(isValid);
        return isValid; // ✅ important: return the value directly
    };

    // Save handler
    const handleSave = () => {
        setTouched({
            fullName: true,
            userId: true,
            password: true,
            userRole: true,
            status: true,
        });

        const valid = validateForm(formData); // ✅ get the result directly

        debugger
        if (valid) { // ✅ no async state dependency
            onSave(formData);
            onHide();
            setFormData({});
            setErrors({});
            setTouched({});
            setIsFormValid(true);
        }
    };


    // Handle input change and re-validate the form
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedData = {
            ...formData,
            [name]: value,
        };
        setFormData(updatedData);
        validateForm(updatedData); // Revalidate the form after input change
    };

    // Handle marking a field as touched
    const handleFieldBlur = (e) => {
        const { name } = e.target;
        setTouched((prevTouched) => ({
            ...prevTouched,
            [name]: true,
        }));
    };

    return (
        <Dialog style={{ width: '350px' }} draggable={false} visible={visible} header={isViewMode ? "View User" : "Update User"} modal onHide={onHide} footer={
            <div>
                <Button label="Close" icon="pi pi-times" onClick={onHide} className="p-button-text" />
                {!isViewMode && (
                    <Button label="Save" icon="pi pi-check" onClick={handleSave} autoFocus/>
                )}
            </div>
        }>
            <div className="p-fluid">
                {errors.error && <small className="p-error">{errors.error}</small>}
                <div className="field">
                    <label htmlFor="fullName">Full Name</label>
                    <InputText id="fullName" name="fullName" autoComplete="off" value={formData.fullName || ''} onChange={handleInputChange} onBlur={handleFieldBlur} readOnly={isViewMode}  className={touched.fullName && errors.fullName ? 'p-invalid' : ''} />
                    {touched.fullName && errors.fullName && <small className="p-error">{errors.fullName}</small>}
                </div>
                <div className="field">
                    <label htmlFor="userId">User ID</label>
                    <InputText id="userId" name="userId" autoComplete="new-password"  value={formData.userId || ''} onChange={handleInputChange} onBlur={handleFieldBlur} readOnly={isViewMode} className={touched.userId && errors.userId ? 'p-invalid' : ''} />
                    {touched.userId && errors.userId && <small className="p-error">{errors.userId}</small>}
                </div>
                <div className="field">
                    <label htmlFor="password">Password</label>
                    <InputText
                        autoComplete="new-password" 
                        id="password"
                        type='password'
                        name="password"
                        value={formData.password || ''}
                        onChange={handleInputChange}
                        onBlur={handleFieldBlur}
                        readOnly={isViewMode}
                        className={touched.password && errors.password ? 'p-invalid' : ''}
                    />
                    {touched.password && errors.password && <small className="p-error">{errors.password}</small>}
                </div>
                <div className="field">
                    <label htmlFor="userRole">User Role</label>
                    <Dropdown filter showClear 
                        value={formData.userRole || null}
                        onChange={handleInputChange}
                        onBlur={handleFieldBlur}
                        readOnly={isViewMode}
                        options={userRolesOptions}
                        id="userRole"
                        name="userRole"
                        optionLabel="name"
                        optionValue="code"
                        placeholder="Select Role"
                        disabled={isViewMode}
                        className={touched.userRole && errors.userRole ? 'p-invalid' : ''}
                    />
                    {touched.userRole && errors.userRole && <small className="p-error">{errors.userRole}</small>}
                </div>
          
                <div className="field">
                    <label htmlFor="status">Status</label>
                    <Dropdown
                        filter
                        showClear
                        value={formData.status || null}
                        onChange={handleInputChange}
                        onBlur={handleFieldBlur}
                        readOnly={isViewMode}
                        options={statusOptions}
                        id="status"
                        name="status"
                        optionLabel="name"
                        optionValue="code"
                        disabled={isViewMode}
                        placeholder="Select status"
                        className={touched.status && errors.status ? 'p-invalid' : ''}
                    />
                    {touched.status && errors.status && (
                        <small className="p-error">{errors.status}</small>
                    )}
                </div>
            

            </div>
        </Dialog>
    );
};

export default UserDialog;
